import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { trackPageView, setUser } from '../services/analyticsService';

// This app has no @okta/okta-react dependency, so it reads auth state from the
// existing AuthContext (useAuth) instead of useOktaAuth().
const AnalyticsTracker: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated, user } = useAuth();

  useEffect(() => {
    console.log('[GA4 Debug] AnalyticsTracker mounted');
  }, []);

  useEffect(() => {
    console.log('[GA4 Debug] AnalyticsTracker - page view:', location.pathname);
    trackPageView(location.pathname);

    if (isAuthenticated && user) {
      const userId = user.sub || user.email;
      if (userId) {
        console.log('[GA4 Debug] AnalyticsTracker - identifying authenticated user:', userId);
        setUser(userId);
      }
    }
  }, [location.pathname, isAuthenticated, user]);

  return null;
};

export default AnalyticsTracker;
